module.exports = __webpack_public_path__ + "static/media/logo.edc03e74.png";